import { Button } from '@tempo-io/sui-button';
import { cn } from '@tempo-io/sui-class-utils';
import { ItemTypeIcon } from '@/components/ui/item-type/itemTypeIcon';
import type { Item } from '@/lib/api/types/items';
import type { ItemTypeMap } from '@/lib/api/types/itemType';
import { useItemPanelNavigation } from '@/lib/hooks/item-panel/useItemPanelParams';

export const ItemValueButton = ({
  item,
  itemTypesById,
}: {
  item: Pick<Item, 'id' | 'name' | 'itemTypeId'>;
  itemTypesById: ItemTypeMap;
}) => {
  const { id: itemId, name, itemTypeId } = item;
  const { openItemPanel } = useItemPanelNavigation();

  const handleClick = () => {
    if (itemId) {
      openItemPanel({ itemId });
    }
  };

  const itemType = itemTypesById[itemTypeId];

  return (
    <Button
      type="button"
      variant="secondary"
      className={cn('w-30 flex basis-[content] gap-1 truncate')}
      onClick={handleClick}
    >
      {!!itemType && <ItemTypeIcon itemType={itemType} />}
      {name}
    </Button>
  );
};
